import React, {
  FC,
} from 'react';
import './housingApplications.scss';
import {
  Route, useLocation,
} from 'react-router-dom';
import DashboardWrap from '../../components/DashboardWrap';
import { AdminRouteName } from '../CONSTANTS';
import MainHousingApplications from './MainHousingApplications';
import RolesAndPermissionGuard from '../../components/RolesAndPermissionGuard';

const HousingApplication: FC = () => {
  const location = useLocation();

  return (
    <DashboardWrap>
      <RolesAndPermissionGuard permissionName="can-view-apartment-detail">
        <div className="housing-application-root">
          <Route
            component={MainHousingApplications}
            path={AdminRouteName.housingApplicationRoute}
            exact
          />
          <Route
            component={MainHousingApplications}
            path={AdminRouteName.housingApplicationStatusRoute}
            exact
            key={location.pathname}
          />
        </div>
      </RolesAndPermissionGuard>
    </DashboardWrap>
  );
};

export default HousingApplication;
